var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_367",
    "data-name": "\\uADF8\\uB8F9 367",
    transform: "translate(-1848 -59)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_88",
    "data-name": "\\uC0AC\\uAC01\\uD615 88",
    width: 32,
    height: 32,
    transform: "translate(1848 59)",
    fill: "#4b63ff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "exit",
    d: "M48.286,96.818V90.909H40.518a.911.911,0,0,1,0-1.818h7.768V83.182a3.1,3.1,0,0,0-3-3.182H35a3.1,3.1,0,0,0-3,3.182V96.818A3.1,3.1,0,0,0,35,100H45.286a3.1,3.1,0,0,0,3-3.182Zm4.788-5.909L50.252,93.9a.949.949,0,0,0,.015,1.269.823.823,0,0,0,1.2.016l4.286-4.545a.949.949,0,0,0,0-1.285l-4.286-4.545a.823.823,0,0,0-1.2.016.949.949,0,0,0-.015,1.269l2.822,2.994H48.286v1.818Z",
    transform: "translate(1820 -15)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.29685fcdce142c221332d3b2fdee8c05.svg";
export { ForwardRef as ReactComponent };